import React from 'react';
import Pro01 from "../../images/services/dev/Experienced-DevOps-Company.webp";
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Agile(props) {
    return (
        <div className="tekrevol_gray_bg p-100">
            <Container classNanme="h-100">
                <Row classNanme="h-100">
                    <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
                        <div className="example" data-text="Experienced ">
                            <h2>Experienced DevOps Company</h2>
                        </div>
                        <p>Integrating Technical Resources and Operations Our DevOps services enable organizations to deliver digital products and solutions and streamline processes faster than traditional software development. While more or less every DevOps company or consultancy would offer you the same, we have reasons our clients chose us – and keep working with us for all things tech. We are inherently a technology company with strong roots in development and years in developing not just products but user-centric experiences. And that makes us the best at what we do – impacting lives through emerging tech stack.</p>

                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="agile_title my-auto offset-xl-1">
                        <div className="content_pointer">
                            <div className="pointers_item">
                                <div className="title_count">55+<span>Applications Delivered</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">34+<span>Businesses Transformed</span></div>
                            </div>
                            <div className="pointers_item">
                                <div className="title_count">11+<span>Industries Served</span></div>
                            </div>
                        </div>
                        <LazyLoadImage
                            src={Pro01}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Agile;